// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"289c04d0","239":"333da94c","308":"cfcf5070","450":"053cf17c","455":"43b72d29","977":"b2950475"}[chunkId] + ".chunk.js";
};